<template>
  <v-card>
    <CardToolbar :title="title" :isModal="true" @cancel="close" />
    <v-card flat class="cardTitle" :color="$style.card.background">
      <v-card-text>
        <v-flex xs12>
          <v-layout>
            <v-flex md5>
              <DateTimePicker
                :range="true"
                v-model="dateTime"
                :initStartDate="start"
                :initEndDate="end"
              ></DateTimePicker>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink class="text-right">
              <div class="font-weight-regular" v-if="dateTime.start">
                <v-layout row justify-end>
                  <v-flex>
                    <div class="text-right">FROM:</div>
                    <div class="text-right">TO:</div>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex shrink>
                    <div class="text-left">
                      <span class="pl-3">{{
                        dateTime.start | moment("LLLL")
                      }}</span>
                    </div>
                    <div class="text-left">
                      <span class="pl-3">{{
                        dateTime.end | moment("LLLL")
                      }}</span>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-text>
    </v-card>
    <v-stepper v-model="el">
      <v-stepper-header>
        <v-stepper-step :complete="el > 1" step="1">
          Verify Password
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="el > 2" step="2">
          Confirmation
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <!-- login-->
        <v-stepper-content step="1">
          <v-card class="mb-12" height="350px">
            <v-card-text>
              <div class="text-center">
                <v-flex>
                  <GoogleLogin v-on:response="checkResponse"></GoogleLogin>
                </v-flex>
                <v-flex class="mb-3">
                  <span>{{ $t("labels.or") }}</span>
                </v-flex>
                <v-flex>
                  <v-text-field
                    data-cy="loginEmail"
                    v-model="email"
                    outlined
                    :disabled="true"
                    label="Email"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    data-cy="loginPassword"
                    outlined
                    v-model="password"
                    :append-icon="
                      showPassword ? 'visibility_off' : 'visibility'
                    "
                    :type="showPassword ? 'text' : 'password'"
                    :label="$t('labels.password')"
                    v-on:keyup.enter.prevent="submit"
                    counter
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-flex>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>
        <!-- step 2 -->
        <v-stepper-content step="2">
          <div class="text-center">
            <v-flex>
              <v-text-field
                data-cy="loginPassword"
                outlined
                v-model="writeDelete"
                label="Write 'delete' in order to continue"
                v-on:keyup.enter.prevent="writeDelete == 'delete' ? el++ : null"
                counter
              ></v-text-field>
            </v-flex>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-card-actions>
      <v-layout align-center justify-end row class="pa-3">
        <v-btn color="primary" flat @click="close">{{
          $t("buttons.cancel")
        }}</v-btn>
        <v-btn color="primary" @click="submit">Continue</v-btn>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import GoogleLogin from "@/modules/Authentication/components/GoogleLogin.vue";
import authService from "@/modules/Authentication/service";
import invoiceService from "@/modules/Invoice/service";
import expenseService from "@/modules/Location/components/Expense/service";
import DateTimePicker from "@/components/DateTimePicker";

export default {
  name: "messages-service",
  props: {
    title: String,
    description: String,
    warningMessage: String,
    stepperDialogData: Object,
    LocationId: Number,
    archiveModuleName: String,
  },
  components: {
    GoogleLogin,
    DateTimePicker,
  },
  data() {
    return {
      el: 1,
      password: null,
      email: null,
      showPassword: false,
      writeDelete: null,
      start: this.$moment().startOf("day"),
      end: this.$moment().endOf("day"),
      dateTime: {
        start: this.$moment().startOf("day").toISOString(),
        end: this.$moment().endOf("day").toISOString(),
      },
      startDatePicker: {
        dialog: false,
        date: null,
      },
      endDatePicker: {
        dialog: false,
        date: null,
      },
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    startDateFormatted: {
      get() {
        if (this.startDatePicker.date) {
          return this.$moment(this.startDatePicker.date).format("MM/DD/YYYY");
        }
        return null;
      },
      set() {
        this.startDatePicker.date = null;
      },
    },
    endDateFormatted: {
      get() {
        if (this.endDatePicker.date) {
          return this.$moment(this.endDatePicker.date).format("MM/DD/YYYY");
        }
        return null;
      },
      set() {
        this.endDatePicker.date = null;
      },
    },
  },
  mounted() {
    this.email = this.currentUser.email;
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async submit() {
      // check login
      if (this.el === 1) {
        await this.submitLogin();
        return true;
      }
      // check spelling
      if (this.el === 2) {
        if (this.writeDelete === "delete") {
          this.el++;

          this.$swal({
            title: "Are you sure you want delete all the transactions ?",
            text: "You won't be able to revert this!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
          }).then((result) => {
            if (result.value) {
              if (this.archiveModuleName === "expense") {
                expenseService
                  .deleteAll({
                    LocationId: this.LocationId,
                    start: this.dateTime.start,
                    end: this.dateTime.end,
                  })
                  .then((response) => {
                    if (response) {
                      this.$swal(
                        "Deleted!",
                        "All transactions have been Deleted",
                        "success"
                      );
                      this.close();
                    }
                  })
                  .catch((error) => {
                    console.log("error", error);
                  });
              } else {
                invoiceService
                  .deleteAll({
                    LocationId: this.LocationId,
                    start: this.dateTime.start,
                    end: this.dateTime.end,
                  })
                  .then((response) => {
                    if (response) {
                      this.$swal(
                        "Deleted!",
                        "All transactions have been Deleted",
                        "success"
                      );
                      this.close();
                    }
                  })
                  .catch((error) => {
                    console.log("error", error);
                  });
              }
            } else {
              this.close();
            }
          });
        } else {
          this.$swal("Text not matched");
          return false;
        }
        this.el = this.el + 1;
        return true;
      }

      if (this.el === 3) {
        this.el = 4;
        return true;
      }
      return true;
    },
    checkResponse(response) {
      if (response.data && response.data.user) {
        this.el = 2;
      }
    },
    submitLogin() {
      return authService
        .verify({
          email: this.email,
          password: this.password,
        })
        .then((response) => {
          this.checkResponse(response);
        })
        .catch(() => {
          this.$swal("Invalid Password");
        });
    },
  },
};
</script>

<style scoped>
</style>
